import React, { useEffect, useRef, useState } from "react";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyCart,
  logoutUser,
  selectCart,
  selectUser,
  setCart,
  updateQuantity,
} from "../ReduxStore/userReducer";
import "./checkout.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import {
  PostCartItemApi,
  SoPostApi,
  removeItemInTable,
  PostSalesQuotation,
  printDataAPI,
  UpdateSalesQuotation,
} from "../API/API";
import SunspotLoader from "../sharedFiles/loader/loader";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import Footer from "../sharedFiles/footer/footer";
import { PostData, PostWithoutData } from "../API/postApi";
import SalesQuotationModal from "../salesQuotationModal/salesQuotationModal";
// import ItemTableView from "../itemPage copy/ItemTableView/ItemTableView";
import { GetData } from "../API/getApi";
import InvoiceReport from "../GenerateReport/generateReport";
import ReportGenerator from "../GenerateReport/generateReport";
import handlePrinter from "../GenerateReport/generateReport";

const Checkout = () => {
  const checkout = useSelector(selectCart);
  const BranchNames = useSelector((state) => state.item.BranchList);
  const dispatch = useDispatch();
  const [showPrintButton,setShowPrintButton]=useState(false);
  const [DueDate, setDueDate] = React.useState(dayjs());
  const Ddate = dayjs(DueDate).format("YYYY-MM-DD");
  const [isLoading, setIsLoading] = useState(false);
  const [valueChange, setValueChange] = useState(false);
  const [remarks, setRemarks] = useState(Object.values(checkout ?? {})[0]?.remarks|| "");
  const userData = useSelector(selectUser);
  const databaseName = userData?.DBName;
  const userId = userData?.UserId;
  const userName = userData?.CardName;
  const jwtToken = userData?.JwtToken;
  const WhsCode = userData?.WarehouseCode;
  const location = useLocation();
 const updateDocEntry=localStorage.getItem('docEntry');
  const orderType = location.state?.orderType;
  
  const navigate = useNavigate();
  const LeadDetails = JSON.parse(localStorage.getItem('CustomerDetails'));
   const [modalShow, setModalShow] = useState(false);
   const [docEntrys, setDocEntrys] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const thead = [
    "itemCode",
    "itemName",
    "cntUnitMsr",
    "itmsGrpCod",
    "lastPurPrc",
    "onHand",
    "quantity",
    "Action",
  ]; 
 
  //********** Filter a user branch id by using a branch name *********/
  const userBranchName = userData?.Branch;
  const matchingBranch = BranchNames?.find(
    (branch) => branch.bplName === userBranchName
  );

  //************ handle a cart update on checkout page ***********/
  const handleUpdateCart = async () => {
    let checkoutArray = Object.values(checkout);
    checkoutArray = checkoutArray.map((item) => {
      let newItem = { ...item }; // Create a new object
      if (!newItem.salUnitMsr) {
        newItem.salUnitMsr = "0";
      }
      return newItem;
    });
    try {
      const responseData = await axios.post(
        `${PostCartItemApi}${userId}`,
        checkoutArray,
        {
          headers: {
            wg_token: jwtToken,
          },
        }
      );
      if (responseData.data === "OK") {
        Swal.fire({
          title:"Cart updated successfully!",
          confirmButtonColor:"#26517b"});
      }
      setValueChange(false);
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  //******* This is for page navigation from checkout to itemPage ***********/
  const handleBackToDashboard = async () => {
    if (valueChange) {
      handleUpdateCart();
    }
    localStorage.removeItem('docEntry')
    localStorage.removeItem('leadDetails')
    localStorage.removeItem('CustomerDetails');
    navigate('/ItemPageModular');

  };


  //******** This is for remove the cart item from table based on userif on successful final post  *******/
  const handleRemoveItem = async (event) => {
    const removeData = await PostWithoutData(
      `${removeItemInTable}${userId}`,
      jwtToken,
      dispatch,
      navigate
    );
  }; 
  //********** This is final post for both sales order and sales quatation **********/
  const handleSubmit = async (event, isOtherCustomer) => {
    event.preventDefault(); 
    setIsLoading(true);
    const CustomerDetails = LeadDetails?.inputValue?.CheckBox==="checked"
    ? `CustomerName: ${LeadDetails?.inputValue?.customer_Name}, Phone: ${LeadDetails?.inputValue?.phone_Number}, Address: ${LeadDetails?.inputValue?.customer_Address}`
    : '';
    const marginPercentage = LeadDetails?.inputValue?.CheckBox==="checked"
    ? LeadDetails?.inputValue?.margin_Percentage 
    : '';
    // const CustomerDetails = `Customer Name: ${LeadDetails.inputValue.customer_Name}, Phone: ${LeadDetails.inputValue.phone_Number}, Address: ${LeadDetails.inputValue.customer_Address}`;
    const checkoutArray = Object.values(checkout);
    // if(!checkoutArray.itemCode || ){
      
    // } // Convert checkout object to array
    //**** Updating a cart array for posting *********/
    const isValidNumber = (value) => {
      return typeof value === "number" && !isNaN(value);
    };
    const updatedCart =
      orderType && orderType === "PurchaseOrder"
        ? checkoutArray.map((row) => ({
            customerCode: userData?.CardCode,
            ItemCode: row.itemCode,
            Price: isValidNumber(row.defaultPriceList)
              ? row.defaultPriceList
              : 0,
            Quantity: row.quantity,
            DeliveryDate: Ddate,
            Remarks: remarks,
            BranchId: userData?.BranchID,
            WareHouseCode: WhsCode ? WhsCode : "SUPGEN",
            SplCode: userData?.SalesEmpCode,
            LeadDetail:CustomerDetails,
            MarginPercentage:marginPercentage,
          }))
        : checkoutArray.map((row) => ({
            customerCode: userData?.CardCode,
            ItemCode: row.itemCode,
            Price: isValidNumber(row.defaultPriceList)
              ? row.defaultPriceList
              : 0,
            Quantity: row.quantity,
            ValidTillDate: Ddate,
            Remarks: remarks,
            BplId: userData?.BranchID,
            WareHouseCode: WhsCode ? WhsCode : "SUPGEN",
            // WareHouseCode: WhsCode ? WhsCode : "CLFREEZD",
            SplCode: userData?.SalesEmpCode,
            LeadDetail:CustomerDetails,
            MarginPercentage:marginPercentage
          }));
          
    const companyName = databaseName;
    //****** In this will add database name to cart item because posting a cart to sap by dynamic database *********/

    let dataToSend;  
    //******* Dynamic API endpoint **********/
    let apiEndpoint;
    if (orderType === "Quote") {
      dataToSend = {
        companyName: companyName,
        quotationData: updatedCart,
      };
      apiEndpoint = PostSalesQuotation;
    }
    if (orderType === "PurchaseOrder") {
      apiEndpoint = SoPostApi;
      dataToSend = {
        companyName: companyName,
        salesOrders: updatedCart,
      };
    }
    try {
      const responseData = await PostData(
        // apiEndpoint,
        dataToSend,
        jwtToken,
        dispatch,
        navigate
      );
    
      if (responseData.status === "OK") {
        setDocEntrys(responseData.docEntry);
        setModalShow(true);
        setShowPrintButton(true);
        handleRemoveItem();
        setIsLoading(false);
        toast("Request successfully created!", {
          position: "bottom-right",
          theme: "dark",
        });
        // localStorage.removeItem('CustomerDetails');
        dispatch(emptyCart()); 
      } else if(responseData.status==='Error') {
        setIsLoading(false);
        localStorage.removeItem('CustomerDetails');
        toast(responseData.message, {
          position: "bottom-right",
          theme: "dark",
        });
      }
    } catch (error) {
      setIsLoading(false);     
          toast(error.message, {
          position: "bottom-right",
          theme: "dark",
      });
    }
  };

 

  const handlecancel=()=>{
    setModalShow(false);
    setShowPrintButton(false);
    
  }

  const handleUpdateSQ =async (event) =>{
    console.log("trigere");
    
    event.preventDefault(); 
    const CustomerDetails = LeadDetails?.inputValue?.CheckBox==="checked"

    ? `CustomerName: ${LeadDetails?.inputValue?.customer_Name}, Phone: ${LeadDetails?.inputValue?.phone_Number}, Address: ${LeadDetails?.inputValue?.customer_Address}`
    : '';
    const marginPercentage = LeadDetails?.inputValue?.CheckBox==="checked"
    ? LeadDetails?.inputValue?.margin_Percentage 
    : '';

    setIsLoading(true);
    const checkoutArray = Object.values(checkout);
    const isValidNumber = (value) => {
      return typeof value === "number" && !isNaN(value);
    };
   const updatedCart = checkoutArray.map((row) => {
        return {
          customerCode: userData?.CardCode,
          ItemCode: row.itemCode,
          Price: isValidNumber(row.price) ? row.price: 0,
          Quantity: row.quantity,
          Remarks: remarks,
          LeadDetail: CustomerDetails,
          MarginPercentage: marginPercentage,
          WareHouseCode: WhsCode ? WhsCode : "SUPGEN",
          // WareHouseCode: WhsCode ? WhsCode : "CLFREEZD",
          SplCode: userData?.SalesEmpCode,
        };
      });
   const dataToSend = {
      companyName: databaseName,
      docEntry :updateDocEntry,
      quotationData: updatedCart,
    }
    try {
      const responseData = await PostData(
        UpdateSalesQuotation,
        dataToSend,
        jwtToken,
        dispatch,
        navigate
      );
      if (responseData === "OK") {
        setModalShow(false);
        setShowPrintButton(true);
        handleRemoveItem();
        localStorage.removeItem('docEntry')
        localStorage.removeItem('leadDetails')
        localStorage.removeItem('cartTable')
        setRemarks('')
        setIsLoading(false);
        toast("Request successfully created!", {
          position: "bottom-right",
          theme: "dark",
        });
        dispatch(emptyCart());   
      } else {
        setIsLoading(false);
        toast(responseData, {
          position: "bottom-right",
          theme: "dark",
        });
      }
    } catch (error) {
      setIsLoading(false);     
          toast(error.message, {
          position: "bottom-right",
          theme: "dark",
      });
    }
    setIsLoading(false);
   }

    const handleprint=async()=>{
     const url = `${printDataAPI}${databaseName}&DocEntry=${docEntrys}&DocType=${orderType}`;
      try {
        const response = await GetData(url, {
          headers: {
            'wg_token': jwtToken
          }
        }, dispatch, navigate);
          if(response.length>0){ 
           handlePrinter(response,orderType,userName)
           setModalShow(false);
           setShowPrintButton(false);
           localStorage.removeItem('CustomerDetails');
           }else{
            toast("Error to Print", {
              position: "bottom-right",
              theme: "dark",
            });
           }
      } catch (error) {
        toast(error, {
          position: "bottom-right",
          theme: "dark",
        });
      }
    
  }

  //******* This will render a empty cart page **********/
  if (!checkout || Object.keys(checkout).length === 0) {
    return (
      <div className="">
        <Header />
        {/* <div className="dashImage"></div> */}
        <div className="cartEmptyDiv">
          <div className="backIconDiv">
            <a onClick={handleBackToDashboard} className="backIcon">
            <ArrowBackIcon />
            </a>
            <p className="emptyname col-12">Item Page</p>
          </div>
          <div className="cartEmptyBg">
            <div className="cartEmpty">
              <div className="cartEmptyImage"></div>
              <p className="cartEmpty-text">
                Oops! There is no Item in your cart
              </p>
            </div>
            <SalesQuotationModal
      show={modalShow}
      onHide={() => setModalShow(false)}
      isLoading={isLoading}
      showPrintButton={showPrintButton}
      handleprint={handleprint}
      handlecancel={handlecancel} 
      />
          </div>

      
        </div>
        <ToastContainer autoClose={3000}
        limit={1}/>
        <Footer />
      </div>
    );
  }

  //****** This is for delete item in cart *********/
  const handleButtonClick = (e, itemCode) => {
    const newQuantity = 0;
    dispatch(updateQuantity({ itemCode, newQuantity }));
    setValueChange(true);
  };

  //****** This is for increase the quantity of items  ********/
  const handleQuantityChange = (e, itemCode) => {
    const newQuantity = e.target.value;
    dispatch(updateQuantity({ itemCode, newQuantity }));
    setValueChange(true);
    // Update the state here...
  };

  //******* This will calculate a total price of the cart item  ******/
  const newCheckout = Object.fromEntries(
    Object.entries(checkout).map(([key, item]) => [
      key,
      { ...item, total: item.defaultPriceList * item.quantity },
    ])
  ); 
  const opens = Boolean(anchorEl);
  const id = opens ? "simple-popover" : undefined;

  // Get keys and add 'total' to keys
  const keys = Object.keys(newCheckout[Object.keys(newCheckout)[0]]);
  // Calculate the total sum
  let totalSum = Object.values(newCheckout).reduce(
    (sum, item) => sum + item.total,
    0
  );


  return (
    <div>
      <Header />
      {/* <div className="dashImage"></div> */}
      <div className="mainCheckout col-12 container-fluid ">
        <div className="CheckbackIconDiv">
          <div className="d-flex justify-content-start mt-3 mt-md-2 mt-xl-2 mt-xxl-2">
            <a onClick={handleBackToDashboard} className="backIcon">
            <ArrowBackIcon />
            </a>
            <p className="checkoutName col-12">
              {orderType && orderType === "PurchaseOrder"
                ? "Purchase Order Checkout"
                : "Quote Checkout"}
            </p>
          </div>
          <div className="DateCustomerDiv col-10 col-md-7 col-xl-5 justify-content-xl-end col-xxl-4 justify-content-xxl-end">
            <div className="CheckDatePicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={
                    orderType && orderType === "PurchaseOrder"
                      ? "Delivery Date"
                      : "Valid Till Date"
                  }
                  className="PRPicker"
                  value={DueDate}
                  minDate={dayjs()}
                  onChange={(newValue) => {
                    setDueDate(newValue);
                  }}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </div>            
          </div>
        </div>
        <div className="col-12 col-xl-12 col-xxl-10 d-flex justify-content-center gap-3 gap-xl-4 gap-xxl-4 maindiv">
          <div className="checkoutItem col-12 col-md-9 col-xl-10 col-xxl-12">
            <div>
              {Object.values(newCheckout).map((item, index) => (
                <div key={index} className="CheckMainDiv">
                  <div className="itemdataDiv">
                    <div className="ItemName">
                      <p className="itemCode">{item.itemCode} :</p>
                      <p>{item.itemName}</p>
                    </div>
                    <div className="ItemQtyDiv">
                      <input
                        value={item.quantity}
                        onChange={(e) => handleQuantityChange(e, item.itemCode)}
                        onClick={(e) => e.target.select()}
                      />
                      <div className="column-action">
                        <Tooltip title="Delete">
                          <button
                            onClick={(e) => handleButtonClick(e, item.itemCode)}
                          >
                            <DeleteForeverIcon />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="priceValue">
                  ₹
                    {Number(item.defaultPriceList).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    /-
                  </div>
                </div>
              ))}
              <div className=" position-relative">
                <div className="totalSum">
                  <p className="">Sub Total - </p>
                  <p className="cell-content">₹{totalSum.toLocaleString()}/-</p>
                </div>
              </div>
            </div>
          </div>
          <div className="placeOrderDiv col-11 col-md-3 col-xl-2 col-xxl-2">
            <div className="final-placeorder-div">
              <div className="subTotalDiv">
                <p className="m-0">Sub Total</p>
                <p className=" m-0 cell-content">{totalSum.toLocaleString()}</p>
              </div>
              <div className=" remarksDiv d-flex flex-column ">
                <textarea
                  name=""
                  className="Remark-textArea"
                  id=""
                  value={remarks}
                  placeholder="Remarks"
                  onChange={(e) => {
                    setRemarks(e.target.value);
                  }}
                ></textarea>
              </div>
              <div className="placeOrderButtonDiv">
                {valueChange ? (
                  <button onClick={handleUpdateCart}>Update Cart</button>
                ) : (
                  <button
                    onClick={updateDocEntry ? handleUpdateSQ : handleSubmit}
                    className=""
                  >
                    {orderType && orderType === "PurchaseOrder"
                      ? "Place a Order"
                      : "Place Quote"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
      {isLoading && (
        <div className="loader position-absolute ">
          (<SunspotLoader />)
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Checkout;
